import { useState, useEffect, useRef } from "react";
import { Check, PlayCircle, RefreshCw, Timer } from "lucide-react";

const youtubeUrl = (q) => `https://www.youtube.com/results?search_query=${encodeURIComponent(q)}`;

export const ExerciseRow = ({ ex, checked, onToggle, onSwap }) => {
  const [restLeft, setRestLeft] = useState(null);
  const intervalRef = useRef(null);

  useEffect(() => () => clearInterval(intervalRef.current), []);

  const startRest = () => {
    if (!ex.rest_sec) return;
    setRestLeft(ex.rest_sec);
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setRestLeft((r) => {
        if (r === null || r <= 1) {
          clearInterval(intervalRef.current);
          return null;
        }
        return r - 1;
      });
    }, 1000);
  };

  return (
    <div className="flex items-start gap-3 py-3 border-b border-white/[0.05] last:border-0" data-testid="mission-exercise-row">
      <button
        onClick={() => onToggle(ex.id)}
        data-testid={`exercise-check-${ex.id}`}
        className={`mt-0.5 w-5 h-5 rounded-full border flex items-center justify-center shrink-0 transition-colors duration-300 ${
          checked ? "bg-kaizen-violet border-kaizen-violet" : "border-white/20"
        }`}
      >
        {checked && <Check size={12} className="text-[#140A24]" />}
      </button>

      <div className="flex-1 min-w-0">
        <p className={`text-sm ${checked ? "text-kaizen-dim2 line-through" : "text-kaizen-text"}`}>{ex.name}</p>
        <p className="text-xs text-kaizen-dim mt-0.5">{ex.setup_steps}</p>
        <div className="flex items-center gap-3 mt-1.5 flex-wrap">
          <span className="text-xs text-kaizen-violetSoft">{ex.sets} × {ex.reps}</span>
          <a
            href={youtubeUrl(ex.youtube_search_query)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`exercise-video-${ex.id}`}
            className="inline-flex items-center gap-1 text-[11px] text-kaizen-violetSoft/80 hover:text-kaizen-violetSoft"
          >
            <PlayCircle size={12} /> Watch form
          </a>
          <button
            onClick={() => onSwap(ex)}
            data-testid={`exercise-swap-${ex.id}`}
            className="inline-flex items-center gap-1 text-[11px] text-kaizen-dim hover:text-kaizen-violetSoft transition-colors duration-300"
          >
            <RefreshCw size={11} /> Swap
          </button>
        </div>
      </div>

      {ex.rest_sec > 0 && (
        <button
          onClick={startRest}
          data-testid={`exercise-rest-${ex.id}`}
          className="shrink-0 flex items-center gap-1 px-2.5 py-1 rounded-full border border-white/10 text-[11px] text-kaizen-dim"
        >
          <Timer size={11} />
          {restLeft != null ? `${restLeft}s` : `${ex.rest_sec}s`}
        </button>
      )}
    </div>
  );
};
